export type Sluggable = {
  slug: string;
};

export const dedupeBySlug = <T extends Sluggable>(items: T[]): T[] => {
  const seen = new Set<string>();
  return items.filter((item) => {
    const isSeen = !seen.has(item.slug);
    seen.add(item.slug);
    return isSeen;
  });
};

/**
 * Produces a map of items keyed by slug
 */
export const toMapBySlug = <T extends Sluggable>(
  items: T[],
): Map<string, T> => {
  const map = new Map<string, T>();
  for (const item of items) {
    map.set(item.slug, item);
  }
  return map;
};

/**
 * Set or append entries keyed by slug
 * @returns a copy
 */
export const updateMapBySlug = <T extends Sluggable>(
  map: Map<string, T>,
  items: T[],
): Map<string, T> => {
  const copy = new Map(map);
  for (const item of items) {
    copy.set(item.slug, item);
  }
  return copy;
};
